export default __webpack_public_path__ + "static/media/02-GlazedPinkDonut.cc3ef2ba.png";